import datevLogo from '@assets/datev.svg'
import React from 'react'
import styled from 'styled-components'

interface Props {
  height?: number
  className?: string
}

export const DatevLogo: React.FC<Props> = ({ height = 16, className }) => (
  <Logo className={className} src={datevLogo} alt="" $height={height} />
)

const Logo = styled.img<{ $height: number }>`
  height: ${({ $height }) => $height}px;
  width: auto;
  flex-shrink: 0;
  object-fit: contain;
  display: block;
`
